export const ErrorMapperWebhostingConst = {
    70006: /* translationId */ 'ERRORS.70006',
    72301: /* translationId */ 'ERRORS.72301'
};
